import { render, staticRenderFns } from "./GiftSetting.vue?vue&type=template&id=748cf70c&scoped=true"
import script from "./GiftSetting.vue?vue&type=script&lang=js"
export * from "./GiftSetting.vue?vue&type=script&lang=js"
import style0 from "./GiftSetting.vue?vue&type=style&index=0&id=748cf70c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748cf70c",
  null
  
)

export default component.exports